module.exports = __webpack_public_path__ + "static/media/serigraphie.06cfebcf.jpg";